import { shiftControlConstants } from '../constant/shiftControl.constants';
import { shiftControl } from '../services/shiftControl.service';
import CONSTANT from '../constant/constant';
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getShiftControlList = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }    
    return dispatch => {
        shiftControl.list(data)
            .then(
                res => {
                    if(!res) return;
                    switch (res['http_code']) {
                        case _errorCode.APISuccess:
                            dispatch(success(res));
                            break;

                        case _errorCode.TOKENExpired:
                            functionCommon.logout()
                            break;
                        
                        case _errorCode.ClientNotPermission:
                            functionCommon.logout();
                            break;

                        default:
                            window.location = '/error/404';
                            break;
                    }
                   
                }
            );
    };

    function success(shiftControlList) { 
        return { type: shiftControlConstants.GET_SUCCESS,  shiftControlList }; 
    }
}
